import { AuthRole } from 'common/enums/enums';
import { useAuth } from 'hooks';
import { useRoleContext } from 'hooks/use-role-context.hook';
import { HasRoles } from 'common/types/types';

export const useHasRoles = (roles: HasRoles) => {
  const { isAuthenticated } = useAuth();
  const { activeRole } = useRoleContext();

  const allowedRoles = Array.isArray(roles) ? roles : [roles];

  if (!isAuthenticated) {
    return false;
  }

  return activeRole ? allowedRoles.includes(activeRole) : false;
};
